import PropTypes from 'prop-types';
import React from 'react';
import DashboardContainer from 'common/dashboard/containers/dashboard-container';
import PermissionCheck from 'common/features/permission-check';
import { isToggleEnabled } from 'react-awesome-feature-toggles/dist/feature-toggles';
import { Row, Col } from 'antd';
import { FormItem, FormText, SubTitle, Div } from 'ui';
import { injectIntl } from 'react-intl';

const TechnicianDashboard = ({ id, renderMenu, intl }) => {
  const renderTechnicianInfo = technicianData =>
    <Div marginTop={10}>
      <Row type='flex' gutter={16}>
        <Col md={12} sm={24} xs={24}>
          <SubTitle>{intl.formatMessage({ id: 'common.titles.INFO' })}</SubTitle>
          <Row type='flex' gutter={8}>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.NAME' })} />
              <FormText>{technicianData.name}</FormText>
            </Col>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.MOBILE_NUMBER' })} />
              <FormText>{technicianData.vanMobile}</FormText>
            </Col>
          </Row>
          <Row type='flex' gutter={8}>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.POSTAL_CODE' })} />
              <FormText>{technicianData.vanPostalCode}</FormText>
            </Col>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.CITY' })} />
              <FormText>{technicianData.vanCity}</FormText>
            </Col>
          </Row>
          {!isToggleEnabled('checkViewFseAddressPermission') ?
            renderAddressDetails(technicianData) :
            <PermissionCheck permissionsList={['viewfseaddress']}>
              {renderAddressDetails(technicianData)}
            </PermissionCheck>}
        </Col>
        <Col md={12} sm={24} xs={24}>
          <SubTitle>{intl.formatMessage({ id: 'common.titles.GENERAL' })}</SubTitle>
          <Row type='flex' gutter={8}>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.REGION' })} />
              <FormText>{technicianData.vanRegion}</FormText>
            </Col>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.SHIP_TO_NUMBER' })} />
              <FormText>{technicianData.vanNumber}</FormText>
            </Col>
          </Row>
          <Row type='flex' gutter={8}>
            <Col md={12} sm={24} xs={24}>
              <FormItem label={intl.formatMessage({ id: 'common.labels.WORKCENTER' })} />
              <FormText>{technicianData.workCenterNumber}</FormText>
            </Col>
          </Row>
        </Col>
      </Row>
    </Div>;

  const renderAddressDetails = technicianData =>
    <Row type='flex' gutter={8}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.STREET' })} />
        <FormText>{technicianData.vanStreet}</FormText>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.HOUSE_NUMBER' })} />
        <FormText>{technicianData.vanHouseNumber}</FormText>
      </Col>
    </Row>;

  return (
    <>
      <DashboardContainer
        type='technician'
        id={id}
        hasNotes={false}
        hasAlert={false}
        hasInfoPane={true}
        hasShortTimeline={true}
        InfoPane={renderTechnicianInfo}
        infoKey='technician'
        renderMenu={renderMenu}
        canCreateTicket={false}
        canCreateOrder={false}
      />
    </>
  );
};

TechnicianDashboard.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(TechnicianDashboard);
